import { Layout } from '@klarna/mp-ui';
import React from 'react';
import Plugin from './Plugin';
export default function Plugins({ plugins }) {
    return (React.createElement(Layout.Grid, null,
        React.createElement(Layout.Section, { verticalSpacing: 'space.300', justifyContent: 'flex-start' }, plugins.map((plugin) => (React.createElement(Layout.Column, { key: plugin.id, desktopWidth: 4, tabletWidth: 6, mobileWidth: 12 },
            React.createElement(Plugin, { key: plugin.id, plugin: plugin, category: 'boost-home/plugin-overview' })))))));
}
